import { render, staticRenderFns } from "./TypesWorkList.vue?vue&type=template&id=dc906430&scoped=true&"
import script from "./TypesWorkList.vue?vue&type=script&lang=js&"
export * from "./TypesWorkList.vue?vue&type=script&lang=js&"
import style0 from "./TypesWorkList.vue?vue&type=style&index=0&id=dc906430&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc906430",
  null
  
)

export default component.exports